import React from "react";

function OfferModal({ offers, setSelectedOffer, totalPrice }) {
    return (
        <div className="modal fade vertically-center offer-modal" id="offerModal" tabIndex="-1" aria-labelledby="offerModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="offerModalLabel">Select an Offer</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" aria-live="polite">
                        {offers?.length > 0 ? (
                            offers.map((offer, index) => {
                                const minAmount = Number(offer.minAmount || 0);
                                const orderTotal = Number(totalPrice);
                                const isEligible = orderTotal >= minAmount;
                                const remaining = !isEligible ? (minAmount - orderTotal) : 0;
                                const badgeText = offer.unit === 'Percent' ? `${offer.value}% OFF` : `₹${offer.value} OFF`;
                                return (
                                    <div className={`offer-card ${isEligible ? 'eligible' : 'locked'}`} key={index}>
                                        <div className="offer-card-left">
                                            <span className="offer-badge">{badgeText}</span>
                                            <div className="offer-name">{offer.name}</div>
                                            <div className="offer-desc">Save {offer.value}{offer.unit === 'Percent' ? '%' : '₹'} on min order ₹{minAmount}</div>
                                            {!isEligible && <div className="offer-remaining">Add ₹{remaining} more to unlock</div>}
                                        </div>
                                        <div className="offer-card-right">
                                            <button
                                                className="offer-apply-btn"
                                                disabled={!isEligible}
                                                data-bs-dismiss={isEligible ? 'modal' : undefined}
                                                onClick={() => isEligible && setSelectedOffer(offer)}
                                            >
                                                {isEligible ? 'APPLY' : 'LOCKED'}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p className="text-center m-0 py-3">No offers available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OfferModal;
